import $ from "jquery";
import Field from "./../field";
import States from "./../../common/api/states";

const State = (($) => {
  class State extends Field {
    getValue() {
      let value = null;
      let index = this._input.selectedIndex;
      if (index) {
        value = this._input.options[index].value;
      }
      return value;
    }

    render() {
      const self = this;

      let id = this.getForm().getID() + "_field_" + this._field.formFieldID;

      this._element = document.createElement("div");
      this._element.classList.add("ion-form-group");
      this._element.classList.add("ion-form-group-state");
      this._element.classList.add("ion-form-group-dropdown");

      // Label
      this._label = document.createElement("label");
      this._label.htmlFor = id;
      this._label.innerText = this._field.label;
      this._element.appendChild(this._label);

      // Input
      this._input = document.createElement("select");
      this._input.id = id;
      this._input.classList.add("ion-form-control");
      this._input.name = this._field.slug;
      this._input.ariaLabel = this._field.label;
      this._element.appendChild(this._input);

      let isRequired = this.getSetting("isRequired", false);
      if (isRequired == "1") {
        this._element.classList.add("ion-is-required");
        this._input.ariaRequired = true;
      }

      // Default Value
      let defaultValue = this.getSetting("defaultValue");

      // Placeholder
      let placeholder = this.getSetting("placeholder", "Select One...");
      let placeholderOption = document.createElement("option");
      placeholderOption.value = "";
      placeholderOption.innerText = placeholder;
      this._input.appendChild(placeholderOption);

      let country = this.getSetting("country", "US");

      States.list(country)
        .done((data) => {
          data.forEach((state) => {
            let option = document.createElement("option");
            option.value = state.stateName;
            option.innerText = state.stateName;
            if (defaultValue == state.stateName) {
              option.selected = "selected";
            }
            self._input.appendChild(option);
          });
        })
        .fail(() => {
          // Ignore for now
        });

      // Instructions
      let instructions = this._renderInstructions();
      if (instructions) {
        this._element.appendChild(instructions);
      }

      // Messages
      this._renderMessages();
      if (this._messages) {
        this._element.appendChild(this._messages);
      }
    }
  }

  return State;
})($);

export default State;
